<div class="modal-content web-popp-content result-popup-width" role="main">        
    <div class="modal-body web-modal-popup mcb-icon">     
        <p> {{dialogData?.message ?  dialogData?.message : txtMessage }} </p>
    </div>
</div>